// src/components/game/ui/HUD.jsx
import React from 'react';

export default function HUD({ stats }) {
  return (
    <div className="absolute top-0 left-0 w-full p-4 flex justify-between items-start pointer-events-none z-50 text-white">
      {/* Left: Player Info */}
      <div className="bg-gray-900/80 p-3 rounded border border-gray-600 shadow-lg">
        <h1 className="text-xl font-bold text-yellow-500">{stats.age ? stats.age.toUpperCase() : 'LOADING'}</h1>
        <p className="text-sm">Level: <span className="text-blue-400">{stats.playerLevel || 'Initiate'}</span></p>
        <p className="text-sm">Role: <span className="text-green-400">{stats.profession}</span></p>
      </div>

      {/* Right: Resources & Badges */}
      <div className="bg-gray-900/80 p-3 rounded border border-gray-600 text-right shadow-lg">
        <p className="font-mono text-xl text-yellow-400">💰 ${stats.resources}</p>
        <p className={`font-mono ${stats.integrity < 30 ? 'text-red-500 animate-pulse' : 'text-blue-300'}`}>
            🛡️ Integrity: {stats.integrity}%
        </p>
        
        {/* Badges List */}
        <div className="mt-2 flex gap-1 justify-end flex-wrap max-w-[200px]">
          {stats.badges && stats.badges.map((b, i) => (
            <span key={i} className="bg-indigo-900/80 px-2 py-0.5 rounded text-[10px] border border-indigo-400 text-indigo-200">
                {b}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}